export const nodeCountStart = {
	clusterlet: 300,
	external_function: 200,
	sensor: 100,
	analytics: 400,
	profile: 500,
	templated_clusterlet: 600,
	infer_engine: 700,
	learn_engine: 800,
	generate_engine: 900
}

export const nodeKeysLabel = {
	clusterlet: "Digital_Twin",
	external_function: "Delegate",
	sensor: "Sensor",
	analytics: process.env.REACT_APP_ANALYTICS,
	profile: "Profile",
	templated_clusterlet: "Template_Clusterlet",
	infer_engine: "Infer Engine",
	learn_engine: "Learn Engine",
	generate_engine: "Generate Engine"
};

export const treeNodesLabel = {
	clusterlet: "Digital Twin",
	external_function: "Delegate",
	sensor: "Sensor",
	analytics: "Analytic",
	profile: "Profile",
	network: "Network",
	instance: "Instance",
	message: "Message",
	rrdef: "Routing Rule",
	user_trigger: "User Trigger",
	section: "Section",
	field: "Field"
}

export const eventStyle = {
	stroke_width: 5,
	arrow_end: "classic-medium-medium",
	stroke: "#80801B",
	path: "",
}

export const constructIds = [
	{ type: "external_function", name: "delegate", id: 1, label: "Delegate" },
	{ type: "clusterlet", name: "digital_twin", id: 2, label: "Digital Twin" },
	{ type: "analytics", name: "analytics", id: 3, label: process.env.REACT_APP_ANALYTICS },
	{ type: "sensor", name: "sensor", id: 4, label: "Sensor" },
	{ type: "instance", name: "instance", id: 5, label: "Instance" },
	{ type: "transaction", name: "transaction", id: 7, label: "Transaction" },
	{ type: "events", name: "events", id: 8, label: "Events" },
	{ type: "nested_transaction", name: "nested_transaction", id: 9, label: "Nested Transaction" },
	{ type: "profile", name: "profile", id: 6, label: "Profile" },
	{ type: "section", name: "section", id: 11, label: "Section" },
	{ type: "field", name: "field", id: 12, label: "Field" },
	{ type: "rrdef", name: "routing_rule", id: 13, label: "Routing Rule" },
	{ type: "user_trigger", name: "user_trigger", id: 22, label: "User Trigger" },
	{ type: "message", name: "message", id: 17, label: "Message" },
	{ type: "network", name: "network", id: 18, label: "Network" },
	{ type: "invoked_transaction", name: "invoked_transaction", id: 19, label: "Invoked Transaction" },
	{ type: "user", name: "user", id: 20, label: "User" },
	{ type: "label_node", name: "label", id: 21, label: "Blueprint" },
	{ type: "utility_functions", name: "utility_functions", id: 10, label: "Utility Functions" },
	{ type: "templated_clusterlet", name: "templated_clusterlet", id: 23, label: "Templated clusterlet" },
	{ type: "templated_transaction", name: "templated_transaction", id: 24, label: "Templated transaction" },
	{ type: "template_delegate", name: "template_delegate", id: 25, label: "Template Delegate" },

	{ type: "infer_engine", name: "infer_engine", id: 3, label: 'Infer' },
	{ type: "learn_engine", name: "learn_engine", id: 3, label: 'Learn' },
	{ type: "generate_engine", name: "generate_engine", id: 3, label: 'Generate' },


]

export const hyperlinkOptions = [{ "title": "Disable", value: "disable" }, { title: "Enable", value: "enable" }]

export const hyperlinkTypes = [
	{ title: "Hyperblox View", value: "urlView" },
	{ title: "Hyperblox Clusterlet", value: "urlClusterlet" },
	{ title: "External Link", value: "urlExternal" },

]

export const getConstructType = (id) => {
	if(id === undefined || id == null){
		return null
	}
	
	const construct = constructIds.find(constructId => constructId.id === id);
	return construct.type;
}

export const getConstructLabel = (id) => {
	if (id !== undefined) {
		const construct = constructIds.find(constructId => constructId.id === id);
		return construct.label;
	}

}

export const getConstructId = (type) => {
	return (constructIds.find(constructId => constructId.type === type)).id;
}

export const delegateWidth = 120;
export const delegateHeight = 120;
export const externalNodeWidth = 100;
export const externalNodeHeight = 100;

export const nextCountReqConstructs = ["clusterlet", "profile", "sensor", "analytics", "external_function"]

export const parentIdReqConstrcuts = ["section", "field"]

export const clusterletConstructTags = ["clusterlet", "sensor", "analytics", "external_function", "profile", "user"]

export const sectionAsChildrenNodes = [1, 2, 3, 4, 6]

export const fieldAsChildrenNodes = [11, 12, 17, 22]

export const nodesWithInstances = [1, 6]

export const nodesWithProfile = [2, 3]

export const cloneClusterletTags = ["clusterlet", "analytics", "sensor", "external_function"]

export const messages = [
	{ type: "onrecv", message: "--instance.<section>.<field> = message.<field> OR message.<CompoundField>.<SimpleField>" },
	{ type: "onrecv", message: "-- instance.field = message.<field> OR message.<CompoundField>.<SimpleField>" },
	{ type: "onsend", message: "--message.<field> = instance.<section>.<field>" },
	{ type: "onsend", message: "--message.<field> = transaction.<CompoundField>.<SimpleField>" },
	{ type: "onsend", message: "--message.<CompoundField> = {}" },
	{ type: "onsend", message: "--message.<CompoundField>.<SimpleField> = transaction.<CompoundField>.<SimpleField>" },

]

export const w = window.screen.availWidth;
export const h = window.screen.availHeight;
export const horizontalLeftMarginPercentage = 20
export const xCordLeftMargin = (horizontalLeftMarginPercentage / 100) * w;
export const horizontalRightMarginPercentage = 10
export const verticalTopMarginPercentage = 10;
export const yCordTopMargin = (verticalTopMarginPercentage / 100) * h;
export const verticalBottomMarginPercentage = 15;
export const blueprintHeight = 1000
export const blueprintWidth = 1500

export const internalSystem = {
	id: 'A',
	type: 'group',
	position: { x: 150, y: 100 },
	data: { label: "Blueprint", 'data-ui-tour': 'your-value-here' },
	style: {
		backgroundColor: '#dfe2e4',
		width: blueprintWidth,
		height: blueprintHeight,
		borderRadius: 10,
		border: '2px dashed #000',
		outlineOffset: -4,
		fontSize: 35,
		color: '#000000'
	},
	draggable: false,

}

export const gapBtwRightBorderAndInternalNode = 200;

export const gapBTWRightBorderAndExternalNode = 200;

export const gapBTWLeftBorderAndExternalNode = 200;

export const internalSystemNodes = ["clusterlet", "profile", "analytics", 'templated_clusterlet', "infer_engine", "learn_engine", "generate_engine"];

export const externalSystemNodes = ['sensor', 'user'];

export const internalSystemNodesTypes = [2, 3, 6,]

export const externalSystemNodeTypes = [4, 20]

export const delegateTypes = [
	{ label: '3GPPASN1 Bridge', value: 'asn1_delegate', icon: "default_delegate_icon", rrdef: [{ direction: 'IN', fields: ['name', 'dir', 'type', 'nastype', 'tinstance', 'ttype', 'tcmd', 'parameters', 'delegate'] }, { direction: 'OUT', fields: ['name', 'dir', 'ttype', 'tcmd', 'delegate'] }] },
	{ label: 'Application Bridge', value: 'app_bridge', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'Cassandra Bridge', value: 'cassandra_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'Computer Vision Bridge', value: 'cv_bridge', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'Diameter Bridge', value: 'diameter_delegate', icon: "default_delegate_icon", rrdef: [{ direction: 'IN', fields: ['name', 'dir', 'commandcode', 'vendorid', 'tinstance', 'commandtype', 'ttype', 'tcmd', 'delegate'] }, { direction: 'OUT', fields: ['name', 'dir', 'commandcode', 'ttype', 'tcmd', 'commandtype', 'delegate'] },] },
	{ label: 'Elastic Search Bridge', value: 'elastic_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'Email Bridge', value: 'email_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'Grafana Bridge', value: 'grafana_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'HTTP Bridge', value: 'http_delegate', icon: "http_delegate", rrdef: [{ direction: 'IN', fields: ['name', 'dir', 'path', 'code', 'tinstance', 'op', 'ttype', 'tcmd', 'parameters', 'delegate'] }, { direction: 'OUT', fields: ['name', 'dir', 'path', 'code', 'host', 'ttype', 'tcmd', 'parameters', 'delegate'] }] },
	{ label: 'HTTP/2 Bridge', value: 'http2_delegate', icon: "http_delegate", rrdef: [{ direction: 'IN', fields: ['name', 'dir', 'path', 'code', 'tinstance', 'op', 'ttype', 'tcmd', 'parameters', 'delegate'] }, { direction: 'OUT', fields: ['name', 'dir', 'path', 'code', 'host', 'ttype', 'tcmd', 'parameters', 'delegate'] },] },
	{ label: 'Influx Bridge', value: 'influx_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'MongoDB Bridge', value: 'mongo_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'MQTT Bridge', value: 'mqtt_delegate', icon: "default_delegate_icon", rrdef: [{ direction: 'IN', fields: ['name', 'dir', 'type', 'topic', 'tinstance', 'ttype', 'tcmd', 'delegate'] }, { direction: 'OUT', fields: ['name', 'dir', 'type', 'ttype', 'tcmd', 'delegate'] }] },
	{ label: 'MySQL Bridge', value: 'mysql_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'PostgreSQL Bridge', value: 'pgsql_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'Radius Bridge', value: 'radius_delegate', icon: "default_delegate_icon", rrdef: [{ direction: 'IN', fields: ['name', 'dir', 'commandcode', 'tinstance', 'commandtype', 'ttype', 'tcmd', 'delegate'] }, { direction: 'OUT', fields: ['name', 'dir', 'commandcode', 'ttype', 'tcmd', 'commandtype', 'delegate'] }] },
	{ label: 'Redis Bridge', value: 'redis_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'Secure Shell Bridge', value: 'ssh_delegate', icon: "ssh_delegate", rrdef: [] },
	{ label: 'SMS/MMS Bridge', value: 'sms_delegate', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'VR Bridge', value: 'vr_bridge', icon: "default_delegate_icon", rrdef: [] },
	{ label: 'Video Bridge', value: 'video_bridge', icon: "default_delegate_icon", rrdef: [] },
	// { label: 'L2TP', value: 'l2tp_delegate' },	
	// { label: 'SBI', value: 'sbi_delegate' },
];

export const rrdefDirectionsList = [
	{ label: 'IN', value: 'IN' },
	{ label: 'OUT', value: 'OUT' },
]

export const rrdefOperationsList = [
	{ label: 'PUT', value: 'PUT' },
	{ label: 'POST', value: 'POST' },
	{ label: 'GET', value: 'GET' },
	{ label: 'DELETE', value: 'DELETE' },
]
export const fieldDimensionOptions = [
	{ title: 1, value: '1' },
	{ title: 2, value: '2' },
	{ title: 3, value: '3' },
	{ title: 4, value: '4' },
	{ title: 5, value: '5' },
	{ title: 6, value: '6' },
	{ title: 7, value: '7' },
	{ title: 8, value: '8' },
	{ title: 9, value: '9' },
	{ title: 10, value: '10' },
	{ title: 11, value: '11' },
	{ title: 12, value: '12' },
	{ title: 13, value: '13' },
	{ title: 14, value: '14' },
	{ title: 15, value: '15' },
	{ title: 16, value: '16' },
	{ title: 17, value: '17' },
	{ title: 18, value: '18' },
	{ title: 19, value: '19' },
	{ title: 20, value: '20' },
	{ title: 21, value: '21' },
	{ title: 22, value: '22' },
	{ title: 23, value: '23' },
	{ title: 24, value: '24' },
];

export const booleanOptions = [
	{ title: 'True', value: true },
	{ title: 'False', value: false },
]

export const commandTypeList = [
	{ label: 'Request', value: 'req' },
	{ label: 'Response', value: 'res' }
]

export const axisOptions = [
	{ title: 'X', value: 'x' },
	{ title: 'Y', value: 'y' },
	{ title: 'Z', value: 'z' },
]

export const orientationOptions = [
	{ title: 'Horizontal', value: 'horizontal' },
	{ title: 'Vertical', value: 'vertical' },
]

export const lineTypeOptions = [
	{ title: 'Straight', value: 'straight' },
	{ title: 'Curve', value: 'curve' },
]

export const dataFlowConstrcuts = ['transaction', 'event'];

export const enableTabStyle = {
	opacity: 1,
	borderBottom: '2px solid red',
	backgroundColor: '#f50057',
}

export const disableTabStyle = {
	opacity: 0.5,
	backgroundColor: 'transparent',
	borderBottom: 'none'
}

export const reset = {
	opacity: 0.5,
	backgroundColor: 'transparent',
	borderBottom: 'none'
}

export const backupRestoreConfig = {
	rowsPerPage: 20
}

export const templateConfig = {
	rowsPerPage: 6
}

export const routingRulesLabels = [
	{ label: 'Name', value: 'name' },
	{ label: 'Direction', value: 'dir' },
	{ label: 'Host', value: 'host' },
	{ label: 'Clusterlet', value: 'ttype' },
	{ label: 'Event', value: 'tcmd' },
	{ label: 'Command Type', value: 'commandtype' },
	{ label: 'Command Code', value: 'commandcode' },
	{ label: 'Parameter', value: 'parameters' },
	{ label: 'Path', value: 'path' },
	{ label: 'Clusterlet Instance', value: 'tinstance' },
	{ label: 'Status Code', value: 'code' },
	{ label: 'Delegate', value: 'delegate' },
	{ label: 'Operation', value: 'op' },
	{ label: 'Type', value: 'type' },
	{ label: 'Vendor ID', value: 'vendorid' },
	{ label: 'Topic', value: 'topic' },
	{ label: 'Nas Type', value: 'nastype' },	
	{ label: 'Target Name Space', value: 'tns' },
];

export const protocolTypes = {
	http: 'http_delegate',
	http2: 'http2_delegate',
	mqtt: 'mqtt_delegate',
	diameter: 'diameter_delegate',
	radius: 'radius_delegate',
	asn1: 'asn1_delegate',
	ssh: 'ssh_delegate',
	app: 'app_bridge',
	cv: 'cv_bridge',
	elastic: 'elastic_delegate',
	graphana: 'grafana_delegate',
	sms: 'sms_delegate',
	email: 'email_delegate',
	mongo: 'mongo_delegate',
	mysql: 'mysql_delegate',
	vr: 'vr_bridge',
	video: 'video_bridge',
	influx: 'influx_delegate'
}


// Array to hold protocols with no routing rules
export const unsupportedProtocols = ['ssh_delegate', 'cv_bridge', 'elastic_delegate', 'grafana_delegate', 'sms_delegate', 'email_delegate', 'mongo_delegate', 'cassandra_delegate', 'redis_delegate', 'vr_bridge', 'video_bridge']

export const supportedProtocols = ['radius_delegate', 'mqtt_delegate', 'http_delegate', 'http2_delegate', 'asn1_delegate', 'diameter_delegate']


export const aiNodes = ["infer_engine", "learn_engine", "generate_engine"]

export const transactionWidth = 700;

export const widgetGroups = [
	{
		"category":"Controls",
		"widgets": [
			{ title: 'Button', value: 'control-button', image:"button" },
			{ title: 'Switch', value: 'control-switch', image:"switch"},
			{ title: 'Slider', value: 'control-slider' , image:"slider"},  
			{ title: 'Joystick', value: 'control-joystick', image:"joystick" },	
		]
	},
	{
		"category":"Graphs & charts",
		"widgets": [
			{ title: 'Heatmap', value: 'chart-heatmap', image:"heatmap"  },
			{ title: 'Bar Chart', value: 'chart-bar' , image:"barchart" },
			{ title: 'Line Chart', value: 'chart-line' , image:"linechart" },
			{ title: 'Stack Bar Chart', value: 'chart-stackbar', image:"stackbarchart"  },
			{ title: 'Pie Chart', value: 'chart-pie', image:"piechart" },
			{ title: 'Radial Pie', value: 'chart-pie-radial', image:"radialpie"  },
			{ title: 'Range Plot', value: 'chart-rangeplot', image:"rangeplot"  },
			{ title: 'Ratio Bar Chart', value: 'chart-ratiobar', image:"ratiobarchart"  },
			{ title: 'Scatter Plot', value: 'chart-scatter', image:"scatterplot"  },
		]
	},
	{
		"category":"Indicators",
		"widgets": [
			{ title: 'Status', value: 'status', image: 'status' },
			{ title: 'Gauge', value: 'gauge', image: 'gauge' },
			{ title: 'String', value: 'string', image: 'string' },
			{ title: 'Counter', value: 'counter', image: 'counter' },
		]
	},
	{
		"category":"Location",
		"widgets": [
			{ title: 'Map', value: 'chart-geomap', image: 'map' },
			{ title: 'Compass', value: 'compass', image: 'compass'},
		]
	},
	{
		"category":"Media",
		"widgets": [
			{ title: 'Image', value: 'image' , image: 'image'},
			{ title: 'Video', value: 'video' , image: 'video'},
			{ title: '3d Model', value: 'model-3d', image: '3dmodel' },
			{ title: '3d Scene', value: 'scene-3d', image: '3dscene' },		
		]
	},
	{
		"category":"List",
		"widgets": [
			{ title: 'Table', value: 'table', image: 'table'},		
		]
	},
	{
		"category":"Others",
		"widgets": [
			{ title: 'Form', value: 'html_form', image: 'form' },
			{title: 'Image Map', value: 'image-map', image: 'imagemap'},
			{title: 'Chat Box', value: 'chat', image: 'chatbox'}		
		]
	},
]

export const stringTypes = ['DateTime' ,'BOOL' ,'JSON' ,'OCTETSTRING' ,'string' ,'struct' ,'table-button' ,'TimeStamp']
export const counterTypes = ['double' , 'FLOAT' , 'INT8' , 'INT16' , 'INT32' , 'INT64' , 'UINT8' , 'UINT16' , 'UINT32' , 'UINT64' ]
export const sensorName = "Physical Entity"

export const getterForSensorName = () => {
	return sensorName
}
